<template>
    <header>
        <div class="header__logo__mobile logo">
            <img alt="Vue logo" src="@/assets/logo.png" height="40" />
            <div class="header__logo-name logo-name">
                <span :style="{ color: 'black' }">Шаблон</span>
            </div>
        </div>
        <div class="header__buttons">
            <ButtonItem
                type="button"
                icon="pi pi-user"
                @click="handlerToggleUserMenuShow"
            />
            <MenuItem ref="menu" :model="userMenu" :popup="true" />
        </div>
    </header>
</template>

<script>
import { userMenu } from "@/data/user-menu";
import { mapGetters } from "vuex";

export default {
    name: "u-header",
    data() {
        return {
            userMenu: [],
        };
    },
    computed: {
        ...mapGetters({
            user: "user/stateUser",
        }),
    },
    created() {
        this.userMenu = userMenu;
    },
    methods: {
        /**
         * обработчик изменения видимости пользовательского меню
         * @param event - событие клика
         */
        handlerToggleUserMenuShow(event) {
            this.$refs.menu.toggle(event);
        },
    },
};
</script>

<style scoped>
header {
    display: flex;
    align-items: center;
    height: 70px;
    padding: 15px 30px;
    background-color: #ffffff;
    justify-content: space-between;
    z-index: 2;
    position: fixed;
    transition: 0.2s;
    margin: 0 0 0 200px;
    width: calc(100% - 200px);
}
.header__buttons {
    display: flex;
    margin-left: auto;
}
</style>
